import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useEmbedStore = defineStore('embedStore', function () {
  const isEmbedded = ref(sessionStorage.getItem('embedded') === 'true')

  function setEmbedded(val) {
    isEmbedded.value = val
    sessionStorage.setItem('embedded', val)
  }

  return {
    isEmbedded,
    setEmbedded,
  }
})
